<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <mat-chip-grid #itemChipList>
    <mat-chip-row
      *ngFor="let item of selectedItems"
      [removable]="removable"
      (removed)="removeElement(selectedItemsControl, item)"
      class="tw-overflow-hidden"
    >
      <span cropText>
        <span *ngFor="let key of optionNameKeys; let i = index">
          {{ isNil(item[key]) ? '' : i === 0 ? item[key] : '| ' + item[key] }}
        </span>
      </span>
      <ui-svg-icon [name]="iconNames.Close" [width]="18" matChipRemove></ui-svg-icon>
    </mat-chip-row>
    <input
      #itemInput
      [formControl]="itemInputControl"
      [matAutocomplete]="itemAutocomplete"
      [matChipInputFor]="itemChipList"
      [matChipInputAddOnBlur]="false"
    />
  </mat-chip-grid>
  <mat-autocomplete
    #itemAutocomplete="matAutocomplete"
    [panelWidth]="panelWidth"
    [class]="'chips-with-generic-search-and-checkboxes'"
    (closed)="onOptionListClosed(itemInput)"
  >
    <mat-option *ngFor="let item of filteredItems" [value]="item">
      <div (click)="$event.stopPropagation(); toggleSelection(item)" class="tw-px-4 tw-w-full tw-flex tw-items-center">
        <mat-checkbox [checked]="item.selected" class="tw-w-full">
          <span *ngFor="let key of optionNameKeys; let i = index">
            {{ isNil(item[key]) ? '' : i === 0 ? item[key] : '| ' + item[key] }}
          </span>
        </mat-checkbox>
      </div>
    </mat-option>
  </mat-autocomplete>
  <ui-svg-icon
    *ngIf="isIconVisible && selectedItemsControl?.value?.length < 2"
    [name]="iconNames.ListView"
    matSuffix
  ></ui-svg-icon>
</mat-form-field>
